import React from 'react'
import Headline from 'gatsby-theme-kn/src/components/atoms/Headline'
import Richtext from 'gatsby-theme-kn/src/components/atoms/Richtext'
import SbEditable from 'storyblok-react'

const TextBlock = ({ block, className }) => {
  if (block.flow === true) {
    return (
      <SbEditable content={block}>
        <section className={`content-block-two-col-flow ${className}`}>
          <div className="content-block-two-col-body">
            <Headline
              kicker={block.kicker}
              headline={block.headline}
              headline_level={block.headline_level}
              subheadline={block.subheadline}
            />
          </div>
          <div className="content-block-two-col-flow-body">
            <div className="row">
              <div className="content-col-1">
                <Richtext text={block.text} flow={true} />
              </div>
            </div>
          </div>
        </section>
      </SbEditable>
    )
  } else {
    return (
      <SbEditable content={block}>
        <section className={`content-block-one-col ${className}`}>
          <div className="content-block-one-col-body">
            <div className="row">
              <div className="content-col-1">
                <Headline
                  kicker={block.kicker}
                  headline={block.headline}
                  headline_level={block.headline_level}
                  subheadline={block.subheadline}
                />
                <Richtext text={block.text} flow={true} />
              </div>
            </div>
          </div>
        </section>
      </SbEditable>
    )
  }
}

export default TextBlock
